import styled from '@emotion/styled';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Spin } from 'antd';
import { Colors, device, PrimaryButtonV2 } from 'utils';
import { Link } from 'react-router-dom';
import { ForgetPasswordV2, SingUpFormV2 } from 'components';
import { authActions } from 'redux/actions';
import PropTypes from 'prop-types';
import { GoogleLogin } from '@react-oauth/google';

const FormItem = Form.Item;
const LoginFormV2Wrapper = styled.div`
  input[type='email'],
  input[type='password'] {
    @media ${device.allMobile} {
      font-size: 16px !important;
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: transparent;
    }
  }
  min-width: 500px;
  @media ${device.allMobile} {
    min-width: 1px;
    padding: 0;
    max-width: 100%;
  }
  h1 {
    font-size: 25px;
    font-weight: bold;
  }
  h3 {
    font-size: 18px;
    color: ${Colors.black};
    font-weight: 600;
    margin: 0;
    @media ${device.allMobile} {
      width: 90%;
      margin: auto;
      margin-bottom: 20px;
    }
  }
  .ant-form-item:last-of-type,
  .ant-form-item:last-of-type button {
    margin: 0;
    min-width: 100%;
  }
  .ant-form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .ant-form-item-label {
      color: ${Colors.GreenColor};
      padding-bottom: 6px;
      label {
        font-weight: 500;
        font-size: 14px;
      }
    }
    .ant-form-item-control-input-content > input,
    .ant-input-affix-wrapper {
      width: 100%;
      padding: 10px 14px;
      border: 1px solid ${Colors.GreenColor};
      border-radius: 10px;
    }
  }
  
  .login-actions {
    display: flex;
    justify-content: space-between;
    color: ${Colors.greenText};
    font-weight: 500;
    padding-bottom: 32px;
    @media ${device.allMobile} {
      font-size: 12px;
    }
  }
`;

class LoginFormV2 extends Component {
  static propTypes = {
    user: PropTypes.object,
    loading: PropTypes.bool,
    errors: PropTypes.array,
    login: PropTypes.func.isRequired,
  };

  state = {
    currentForm: 'login',
    redirectToNextStep: false, // Add a state variable to manage redirection
  };

  onFinish = (values) => {
    const { login } = this.props;
    login(values);
    this.setState({ redirectToNextStep: true });
  };

  handleCurrentFormState = (currentForm) => {
    this.setState({ currentForm });
  };

  handleSuccess = (response) => {
    const token = response.credential;
    this.props.loginWithGoogle({ token });
    this.setState({ redirectToNextStep: true });
  };

  handleError = () => {
    console.log('Google login failed');
  };

  render() {
    const { currentForm, redirectToNextStep } = this.state;
    const {
      loading,
      user,
      navigate,
      handelCloseModal,
      setDoPayment,
      handleGetRecurringPayment,
    } = this.props;

    const userToken = localStorage.getItem('access-token');
    const client = localStorage.getItem('client');
    const isLoggedIn = !user?.user && userToken && client;

    if (isLoggedIn && navigate === false) {
      handelCloseModal();
      if (setDoPayment) {
        setDoPayment(true);
      }
    }
    if (isLoggedIn && handleGetRecurringPayment) {
      handleGetRecurringPayment();
    }

    if (redirectToNextStep && isLoggedIn) {
      this.props.onLoginSuccess();
    }

    return (
      <LoginFormV2Wrapper>
        {currentForm === 'login' && (
          <Spin spinning={loading}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '4px',
                textAlign: 'center',
              }}
            >
              <h3>Anmelden</h3>
              <p>Bitte melde dich an, um fortzufahren.</p>
            </div>
            <Form name="login" onFinish={this.onFinish} layout="vertical">
              <FormItem
                name="email"
                label="E-Mail"
                rules={[
                  {
                    required: true,
                    message: 'Bitte gib deine E-Mail Adresse ein.',
                  },
                ]}
              >
                <Input type="email" placeholder="Deine E-Mail-Adresse" />
              </FormItem>
              <FormItem
                label="Passwort"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Bitte gib dein Passwort ein.',
                  },
                ]}
              >
                <Input.Password placeholder="••••••••" />
              </FormItem>
              <div className="login-actions">
                <Link
                  className="register-button"
                  to="#!"
                  onClick={() => {
                    this.handleCurrentFormState('register');
                  }}
                >
                  Neu hier? Jetzt registrieren!
                </Link>
                <Link
                  className="register-button"
                  to="#!"
                  onClick={() =>
                    this.setState({ currentForm: 'forget-password' })
                  }
                >
                  Passwort vergessen?
                </Link>
              </div>
              <FormItem>
                <PrimaryButtonV2 htmltype="submit" style={{ width: '100%' }}>
                  Anmelden
                </PrimaryButtonV2>
              </FormItem>
              <FormItem>
                <GoogleLogin
                  onSuccess={this.handleSuccess}
                  onError={this.handleError}
                />
              </FormItem>
            </Form>
          </Spin>
        )}
        {currentForm === 'register' && (
          <>
            <SingUpFormV2
              handleCurrentFormState={this.handleCurrentFormState}
              handelCloseModal={handelCloseModal}
              navigate={navigate}
              onRegisterSuccess={this.props.onRegisterSuccess}
            />
          </>
        )}
        {currentForm === 'forget-password' && (
          <>
            <ForgetPasswordV2
              handleCurrentFormState={this.handleCurrentFormState}
            />
          </>
        )}
      </LoginFormV2Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors, isLoggedIn } = state.authentication;
  const { donationType } = state.payment;
  return {
    user,
    loading,
    errors,
    donationType,
    isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: (user) => dispatch(authActions.login(user)),
  loginWithGoogle: (user) => dispatch(authActions.loginWithGoogle(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(LoginFormV2);
